// source: rcm_messages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.EDM.IPC.RCM_Runner_Notify_Message', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.EDM.IPC.RCM_Runner_Notify_Message = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.EDM.IPC.RCM_Runner_Notify_Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.EDM.IPC.RCM_Runner_Notify_Message.displayName = 'proto.EDM.IPC.RCM_Runner_Notify_Message';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.toObject = function(opt_includeInstance) {
  return proto.EDM.IPC.RCM_Runner_Notify_Message.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EDM.IPC.RCM_Runner_Notify_Message} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.toObject = function(includeInstance, msg) {
  var f, obj = {
    p1: jspb.Message.getFieldWithDefault(msg, 1, 0),
    p2: jspb.Message.getFieldWithDefault(msg, 2, 0),
    p3: jspb.Message.getFieldWithDefault(msg, 3, 0),
    p4: jspb.Message.getFieldWithDefault(msg, 4, 0),
    p5: jspb.Message.getFieldWithDefault(msg, 5, ""),
    p6: jspb.Message.getFieldWithDefault(msg, 6, ""),
    p7: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    p8: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.EDM.IPC.RCM_Runner_Notify_Message;
  return proto.EDM.IPC.RCM_Runner_Notify_Message.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EDM.IPC.RCM_Runner_Notify_Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setP1(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setP2(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setP3(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setP4(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setP5(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setP6(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setP7(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setP8(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.EDM.IPC.RCM_Runner_Notify_Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EDM.IPC.RCM_Runner_Notify_Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getP1();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getP2();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getP3();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getP4();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getP5();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getP6();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getP7();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getP8();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional int32 P1 = 1;
 * @return {number}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP1 = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 P2 = 2;
 * @return {number}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP2 = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 P3 = 3;
 * @return {number}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP3 = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 P4 = 4;
 * @return {number}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP4 = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string P5 = 5;
 * @return {string}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP5 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string P6 = 6;
 * @return {string}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP6 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP6 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool P7 = 7;
 * @return {boolean}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP7 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP7 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool P8 = 8;
 * @return {boolean}
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.getP8 = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.EDM.IPC.RCM_Runner_Notify_Message} returns this
 */
proto.EDM.IPC.RCM_Runner_Notify_Message.prototype.setP8 = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


goog.object.extend(exports, proto.EDM.IPC);
